<div class="account-setup">
  <div>
    <div class="step-text"></div>
    <div class="col-12">
      <div class="header-text heading" role="heading" aria-level="1">
        <adp-label labelKey="Signup_NewUser_PasswordSetup_Heading_Text"></adp-label>
      </div>
    </div>
  </div>
  <div class="password-container">
    <form [formGroup]="passwordForm" (ngSubmit)="onSubmit($event)">
      <div class="row">
        <div class="col-12">
          <p class="choose-pass"><adp-label labelKey="Signup_NewUser_PasswordSetup_SubHeading_Text"></adp-label></p>
        </div>
      </div>
      <div class="row create-pass-row mb-3">
        <div class="col-12">
          <p class="create-pass"><adp-label labelKey="Signup_NewUser_PasswordSetup_CreatePassword_Heading_Text"></adp-label></p>
          <p class="pass-text"><adp-label labelKey="Signup_NewUser_PasswordSetup_CreatePassword_Body_Text"></adp-label></p>
          <pgh-password-form [forFormGroup]="passwordForm" [passwordLabelSFKey]="'PasswordForm_PasswordField_Label'" [confirmPasswordLabelSFKey]="'PasswordForm_ConfirmPasswordField_Label'"></pgh-password-form>          
        </div>
      </div>
      <div class="row create-pass-row mb-3">
        <adp-input class="w-100" [resourceData]="resourceService.getResourceObject('Signup_NewUser_PasswordSetup_PhoneNumber_Field')" formControlName="mobileNumber"></adp-input>        
      </div>
      <div class="col-12 pb-2">
        <div class="form-group">
          <button mat-flat-button color="accent" type="submit" [disabled]="passwordForm.invalid">
            <adp-label labelKey="Signup_NewUser_PasswordSetup_SubmitButton_Text"></adp-label>
          </button>
        </div>
      </div>
    </form>
  </div>
</div>